module.exports = "/virtual-football-league/img/amblems/right/logos/SEVILLA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/SEVILLA.png
// module id = 2227
// module chunks = 4